import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getPendingVerification, setPendingVerification, clearPendingVerification } from "@/utils/secureStorage";

/**
 * Custom hook for managing OTP verification state
 */
export const useOtpVerification = () => {
  const location = useLocation();
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isLoading, setIsLoading] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const [resendCountdown, setResendCountdown] = useState(0);
  const [isInitialized, setIsInitialized] = useState(false);

  // Get state from location or secure storage
  const pendingVerification = getPendingVerification();
  const email = location.state?.email || pendingVerification.email;
  const userId = location.state?.userId || pendingVerification.userId;
  const loginType = location.state?.loginType || "user";

  useEffect(() => {
    // Set initialized after first render
    const timer = setTimeout(() => {
      setIsInitialized(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return {
    otp,
    setOtp,
    isLoading,
    setIsLoading,
    isResending,
    setIsResending,
    resendCountdown,
    setResendCountdown,
    isInitialized,
    email,
    userId,
    loginType,
  };
};
